export default "__VITE_ASSET__BGfSOSO9__"